import { useMemo } from 'react'
import Box from '@mui/material/Box'
// `uqr`: a zero-dependency encoder whose `encode` answers the module grid
// and nothing else, so the code is drawn here as SVG with no canvas and
// no markup injected. `qrcode` was the alternative and brings PNG,
// terminal and CLI renderers (and their dependencies) this never draws.
import { encode } from 'uqr'

/**
 * A QR code, drawn client-side. What it encodes never leaves the page —
 * which is the point for the one thing it draws, an authenticator secret.
 *
 * Dark on a fixed white ground whatever the theme, because a scanner
 * reads contrast and an inverted code is one many phone apps refuse.
 */
export function QrCode({ value, size = 192, label }: { value: string; size?: number; label: string }) {
  const { path, extent } = useMemo(() => {
    const { data, size: modules } = encode(value, { ecc: 'M', border: 2 })
    let d = ''
    data.forEach((row, y) =>
      row.forEach((dark, x) => {
        if (dark) d += `M${x} ${y}h1v1h-1z`
      }),
    )
    return { path: d, extent: modules }
  }, [value])

  return (
    <Box sx={{ bgcolor: '#fff', lineHeight: 0, borderRadius: 1, display: 'inline-block' }}>
      <svg
        role="img"
        aria-label={label}
        width={size}
        height={size}
        viewBox={`0 0 ${extent} ${extent}`}
        shapeRendering="crispEdges"
      >
        <path d={path} fill="#000" />
      </svg>
    </Box>
  )
}
